export default __webpack_public_path__ + "static/media/fiona_wood.9af4cdee.jpg";